<template>
  <b-card>
    <div class="d-flex">
      <h4 class="mb-0">Contact Information</h4>
    </div>

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12" v-if="contactData.contact_image_url">
            <hr />
            <img
              style="width: 350px"
              :src="contactData.contact_image_url"
            />
          </b-col>
          <b-col cols="12">
            <hr />
          </b-col>
          <b-col md="12">
            <b-form-group label="Contact Image" label-cols-md="3">
              <el-upload
                class="avatar-uploader"
                list-type="picture-card"
                ref="upload"
                :action="uploadUrl"
                :headers="headerObj"
                name="image_file"
                :file-list="fileList"
                multiple
                :limit="1"
                :data="contactData"
                :on-change="onChange"
                :auto-upload="false"
                :class="{ hideUpload: !showUpload }" 
              >
                <img
                  v-if="contactData.contact_image_path && false"
                  :src="getImgPath(contactData.contact_image_path)"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
        
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Form Actions -->

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Save
            </b-button>
            
          </div>
      </b-form>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BCard,
  BCardBody,
  BButton,
  BFormCheckbox,
  BFormDatepicker,
  BInputGroupAppend,
  BInputGroup,
  BFormInvalidFeedback,
  BOverlay,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import contactStoreModule from "./contactStoreModule";
import { ref, onUnmounted } from "@vue/composition-api";
import {getUserData} from '@/auth/utils'

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BFormCheckbox,
    BFormDatepicker,
    BInputGroupAppend,
    BInputGroup,
    BFormInvalidFeedback,
    BOverlay,
  },
  methods: {
    toggleUpload() {
        this.showUpload = !this.showUpload
      },
    getImgPath(path) {
      return process.env.VUE_APP_IMAGE_URL + path;
    },
    onSubmit() {
      this.$swal({
        title: "Are you sure?",
        showCancelButton: true,
        confirmButtonText: "Save",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData()
          formData.append('store_id', getUserData().store_id)
          formData.append('file', this.contactData.file)
          this.loading = true;
          store
            .dispatch("contact/addContact", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });

              this.refetchData()
              if (this.contactData.id == 0) {
                // Return to contact list
                this.hide();
              }


            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });

           
        }
      });
    },
  },
  setup() {
    const loading = ref(false);
    const fileList = ref([]);
    const contactData = ref({});
    const BANNER_STORE_MODULE_NAME = "contact";
    const image_base_url = ref("");
    const showUpload = ref(true)

    if (!store.hasModule(BANNER_STORE_MODULE_NAME))
      store.registerModule(BANNER_STORE_MODULE_NAME, contactStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(BANNER_STORE_MODULE_NAME))
        store.unregisterModule(BANNER_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      store
        .dispatch(BANNER_STORE_MODULE_NAME + "/fetchStore")
        .then((response) => {
          contactData.value = response.data.data;
          image_base_url.value = response.data.image_base_url;
          console.log(response.data.data);
        });
    };

    refetchData();

    const onChange = (file, fileLists) => {
      showUpload.value = !showUpload.value
      contactData.value.file = file.raw;
    };

    const uploadUrl = ref(process.env.VUE_APP_SERVICE_URL + "/contact");
    const headerObj = {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    };

    return {
      loading,
      fileList,
      onChange,
      refetchData,
      contactData,

      // For Image
      uploadUrl,
      headerObj,
      showUpload,
    };
  },
};
</script>

<style lang="scss">
</style>